import {
  IonButtons,
  IonContent,
  IonHeader,
  IonLoading,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToast,
  IonToolbar,
} from "@ionic/react";
import React, { useEffect, useState, useMemo } from "react";
import { useHistory, useParams } from "react-router";
import "./SavingsReport.css";
import { Link } from "react-router-dom";
import {
  Box,
  Typography,
  Avatar,
  IconButton,
  Divider,
  InputLabel,
  MenuItem,
  TextField,
  FormControl,
  Autocomplete,
  Button,
  Table,
  TableBody,
  TableHead,
  TableRow,
  styled,
  TableCell,
  tableCellClasses,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  Card,
  CardContent,
  Grid,
  Chip,
  InputAdornment,
  useTheme,
  alpha
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
 import axios from "axios";
import {
  Search as SearchIcon,
  Add as AddIcon,
  AccountBalance as AccountBalanceIcon,
  People as PeopleIcon,
  AttachMoney as MoneyIcon,
  FilterList as FilterIcon
} from "@mui/icons-material";
import { baseUrl, config, requestID } from "../../common/utils";

const SavingsReport = () => {
    const history = useHistory();
    const theme = useTheme();
    
    // const url = "http://localhost/rmfwarri"

    const { name } = useParams<{ name: string }>();
    const [status, setStatus] = useState({ loading: false, error: false });
    const [users, setUsers] = useState<any[]>([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [members, setMembers] = useState<any[]>([]);
    const [filterOpen, setFilterOpen] = useState(false);

    const fetchUsers = async () => {
        setStatus({ loading: true, error: false });
        try {
            const formData = new FormData();
            formData.append("requestID", requestID());
            
            // Add actual business_id and branch_id if available
            // formData.append("business_id", "your_business_id");
            // formData.append("branch_id", "your_branch_id");

            

            console.log("Fetching from:", baseUrl() + "users/getAllUser_caas");
            
            const response = await axios.post(
                baseUrl() + "users/getAllUser_caas",
                formData,
                config
            );
            
            console.log("API Response:", response);
            
            // Check different response structures
            const responseData = response.data;
            let usersData = [];
            
            if (responseData.data) {
                usersData = responseData.data; // If data is in response.data.data
            } else if (responseData.users) {
                usersData = responseData.users; // If data is in response.data.users
            } else if (Array.isArray(responseData)) {
                usersData = responseData; // If response is directly an array
            }
            
            setUsers(usersData || []);
            setStatus({ loading: false, error: false });

        } catch (error) {
            console.error("Error fetching users:", error);
            setStatus({ loading: false, error: true });
        }
    };

    // Search filter
    const filteredUsers = useMemo(() => {
        return users.filter(
            (u) =>
                u.uname?.toLowerCase().includes(search.toLowerCase()) ||
                u.email?.toLowerCase().includes(search.toLowerCase()) ||
                u.phone?.toLowerCase().includes(search.toLowerCase())
        );
    }, [users, search]);

    // Totals
    const totals = useMemo(() => {
        let totalSavings = 0;
        filteredUsers.forEach((u) => {
            totalSavings += Number(u.amount || u.savingAmount || u.balance || 0);
        });
        return { totalSavings };
    }, [filteredUsers]);

    // Table styling
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            fontWeight: 'bold',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
        },
        "&:last-child td, &:last-child th": {
            border: 0,
        },
    }));

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <IonPage className="pushDown">
            <IonHeader>
                <IonToolbar className="savings-header">
                    <IonTitle>
                        <div className="header-container">
                            {/* Left: Logo + Coop Title */}
                            <div className="header-left">
                                 <Typography variant="h6" className="coop-titlex">
SAVINGS  PAGE                                </Typography>
                            </div>

                            {/* Right: User Info */}
                            <div className="header-right">
                                <div className="header-user">
                                    {/* <Avatar
                                        alt="User"
                                        src="/profile.jpg"
                                        className="header-avatar"
                                    /> */}
                                    {/* <Typography variant="body1" className="user-name">
                                        {name}
                                    </Typography> */}
                                </div>
                            </div>
                        </div>
                    </IonTitle>

                    <IonButtons slot="start">
                        <IonMenuButton className="menu-button" />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen>
                <Box className="savings-content">
                    <Typography variant="h4" component="h1" className="page-title">
                        <AccountBalanceIcon fontSize="large" /> Savings Report
                    </Typography>

                    {/* Stats Cards */}
                    <Grid container spacing={3} className="stats-grid">
                        <Grid item xs={12} md={4}>
                            <Card className="stat-card members-card">
                                <CardContent className="stat-content">
                                    <PeopleIcon className="stat-icon" />
                                    <Box>
                                        <Typography
                                            variant="h3"
                                            component="div"
                                            className="stat-number"
                                        >
                                            {filteredUsers.length}
                                        </Typography>
                                        <Typography variant="body2" className="stat-label">
                                            Total Members
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card className="stat-card savings-card">
                                <CardContent className="stat-content">
                                    <MoneyIcon className="stat-icon" />
                                    <Box>
                                        <Typography
                                            variant="h3"
                                            component="div"
                                            className="stat-number"
                                        >
                                            ₦{totals.totalSavings.toLocaleString()}
                                        </Typography>
                                        <Typography variant="body2" className="stat-label">
                                            Total Savings
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card className="stat-card active-card">
                                <CardContent className="stat-content">
                                    <AccountBalanceIcon className="stat-icon" />
                                    <Box>
                                        <Typography
                                            variant="h3"
                                            component="div"
                                            className="stat-number"
                                        >
                                            {
                                                filteredUsers.filter((u) => Number(u.amount || u.savingAmount || u.balance || 0) > 0)
                                                    .length
                                            }
                                        </Typography>
                                        <Typography variant="body2" className="stat-label">
                                            Active Savers
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                    {/* Search Section (Add Member button removed) */}
                    <Paper elevation={2} className="search-section">
                        <Box className="search-controls">
                            <TextField
                                className="search-bar"
                                placeholder="Search by name, email or phone"
                                variant="outlined"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setFilterOpen(!filterOpen)}
                                startIcon={<FilterIcon />}
                                className="filter-button"
                            >
                                Filters
                            </Button>

                            {/* ADD MEMBER BUTTON REMOVED FROM HERE */}
                        </Box>

                        {filterOpen && (
                            <Box className="filter-panel">
                                <Typography variant="subtitle2" gutterBottom>
                                    Advanced Filters
                                </Typography>
                                <Box className="filter-controls">
                                    <TextField
                                        label="Min Savings"
                                        type="number"
                                        size="small"
                                        className="filter-field"
                                    />
                                    <TextField
                                        label="Max Savings"
                                        type="number"
                                        size="small"
                                        className="filter-field"
                                    />
                                    <FormControl size="small" className="filter-field">
                                        <InputLabel>Status</InputLabel>
                                        <Select label="Status">
                                            <MenuItem value="active">Active</MenuItem>
                                            <MenuItem value="inactive">Inactive</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        className="apply-filters-button"
                                    >
                                        Apply Filters
                                    </Button>
                                </Box>
                            </Box>
                        )}
                    </Paper>

                    {/* Table */}
                    <Paper elevation={2} className="table-paper">
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>S/N</StyledTableCell>
                                    <StyledTableCell>Name</StyledTableCell>
                                    <StyledTableCell>Email</StyledTableCell>
                                    <StyledTableCell>Phone</StyledTableCell>
                                    <StyledTableCell>Monthly Saving</StyledTableCell>
                                    <StyledTableCell>No Saving Amount</StyledTableCell>
                                    <StyledTableCell align="right">
                                        Saving Balance
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredUsers.length > 0 ? (
                                    filteredUsers
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, i) => (
                                            <StyledTableRow key={i}>
                                                <StyledTableCell>
                                                    {page * rowsPerPage + i + 1}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Box className="member-cell">
                                                        <Avatar className="member-avatar">
                                                            {row.uname
                                                                ? row.uname.charAt(0).toUpperCase()
                                                                : "U"}
                                                        </Avatar>
                                                        {row.uname || "N/A"}
                                                    </Box>
                                                </StyledTableCell>
                                                <StyledTableCell>{row.email || "N/A"}</StyledTableCell>
                                                <StyledTableCell>{row.phone || "N/A"}</StyledTableCell>
                                                <StyledTableCell>
                                                    {row.savingAmount || "0"}
                                                </StyledTableCell>
                                                <StyledTableCell>{row.sn || "0"}</StyledTableCell>
                                                <StyledTableCell align="right">
                                                    <Chip
                                                        label={`₦${Number(
                                                            row.amount || row.balance || 0
                                                        ).toLocaleString()}`}
                                                        color={
                                                            Number(row.amount || row.balance || 0) > 0
                                                                ? "success"
                                                                : "default"
                                                        }
                                                        variant={
                                                            Number(row.amount || row.balance || 0) > 0
                                                                ? "filled"
                                                                : "outlined"
                                                        }
                                                        size="small"
                                                        className="savings-chip"
                                                    />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                ) : (
                                    <TableRow>
                                        <TableCell
                                            colSpan={7}
                                            align="center"
                                            className="empty-state"
                                        >
                                            <Typography variant="body1" color="textSecondary">
                                                {search
                                                    ? "No members match your search"
                                                    : "No members found"}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                        {/* Pagination */}
                        <TablePagination
                            component="div"
                            count={filteredUsers.length}
                            page={page}
                            onPageChange={(e, newPage) => setPage(newPage)}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(e) => {
                                setRowsPerPage(parseInt(e.target.value, 10));
                                setPage(0);
                            }}
                            rowsPerPageOptions={[5, 10, 25]}
                            className="pagination"
                        />
                    </Paper>

                    <IonLoading
                        message="Loading..."
                        spinner="circles"
                        isOpen={status.loading}
                    />
                </Box>
            </IonContent>
        </IonPage>
    );
};

export default SavingsReport;